
import {createSlice} from "@reduxjs/toolkit";

export const crudSnackbarSlice = createSlice({
    name: 'crudSnackbarSlc',
    initialState: {value: {crudOpen: false, crudSeverity: "", crudMessage: ""}},
    reducers:
        {
            changeCrudSnackbar: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeCrudSnackbar } = crudSnackbarSlice.actions;

export default  crudSnackbarSlice.reducer ;


